import React from 'react';
import { Box, Typography } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import praxi01 from '../assets/praxis-01.jpg';

function Praxis() {
  return (
    <Box>
      {/* Header Banner */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #1B5E20 0%, #2E7D32 60%, #388E3C 100%)',
          py: { xs: 7, md: 10 },
          px: 3,
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Box sx={{
          position: 'absolute', top: -80, right: -80, width: 350, height: 350,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(255,255,255,0.05) 0%, transparent 70%)',
          pointerEvents: 'none',
        }} />
        <Typography
          sx={{
            fontFamily: '"Playfair Display", serif',
            fontStyle: 'italic',
            color: '#D4A843',
            fontSize: '1rem',
            letterSpacing: 2,
            textTransform: 'uppercase',
            mb: 1,
          }}
        >
          Wo Sie mich finden
        </Typography>
        <Typography
          variant="h3"
          sx={{
            color: '#fff',
            fontFamily: '"Playfair Display", serif',
            fontSize: { xs: '1.8rem', md: '2.5rem' },
          }}
        >
          Meine Praxis
        </Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.75)', mt: 2, fontSize: { xs: '0.97rem', md: '1.05rem' } }}>
          Ich freue mich auf Ihren Besuch in Berlin
        </Typography>
      </Box>

      {/* Praxis Content */}
      <Box sx={{ py: { xs: 6, md: 10 }, px: 3, maxWidth: 800, mx: 'auto' }}>
        <Box
          sx={{
            borderRadius: '24px',
            border: '1px solid rgba(76,175,80,0.12)',
            backgroundColor: '#FDFAF4',
            boxShadow: '0 8px 40px rgba(46,125,50,0.09)',
            overflow: 'hidden',
          }}
        >
          <Box sx={{ height: 4, background: 'linear-gradient(90deg, #1B5E20, #D4A843, #4CAF50)' }} />

          {/* Praxis Image */}
          <Box
            component="img"
            src={praxi01}
            alt="Praxisansicht Sylwia Spiller"
            sx={{
              width: '100%',
              height: { xs: 220, sm: 320, md: 380 },
              objectFit: 'cover',
              display: 'block',
            }}
          />

          {/* Praxis Info */}
          <Box
            sx={{
              p: { xs: 3, md: 5 },
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: 4,
              alignItems: { xs: 'center', sm: 'flex-start' },
            }}
          >
            {/* Map */}
            <Box sx={{ flexShrink: 0 }}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d885.0116530556489!2d13.260368768007233!3d52.44419928294495!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a85bbb8f0ef7d5%3A0x7ce97e37308d91bd!2sLotus-Nail-Spa!5e0!3m2!1sde!2sde!4v1748769171307!5m2!1sde!2sde"
                width="220"
                height="170"
                style={{
                  borderRadius: '12px',
                  border: '0',
                  display: 'block',
                  maxWidth: '100%',
                }}
                allowFullScreen=""
                loading="lazy"
                title="Praxis Standort"
              />
            </Box>

            {/* Address */}
            <Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                <LocationOnIcon sx={{ color: '#2E7D32', fontSize: 22 }} />
                <Typography
                  variant="h6"
                  sx={{ fontFamily: '"Playfair Display", serif', color: '#1B5E20' }}
                >
                  Praxis Berlin-Zehlendorf
                </Typography>
              </Box>
              <Typography sx={{ color: '#5C5244', lineHeight: 2, fontSize: '0.97rem' }}>
                Heilpraktikerin Sylwia Spiller<br />
                im Kosmetikstudio Lotus-Nail-Spa<br />
                Riemeisterstraße 39 a<br />
                14169 Berlin
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default Praxis;
